import anime from 'animejs'
import { OPEN, CLOSE, CONTENT, BACKGROUND } from 'constants/animationConstants';

type AnimateType = 
  | typeof OPEN
  | typeof CLOSE

const animate = (animationItems: any, type: AnimateType): Promise<void> => {
  const content = [...animationItems[CONTENT]]
  const background = [...animationItems[BACKGROUND]]
    

  switch(type) {
    case OPEN: {     
      return new Promise((resolve, reject) => {  
        anime({
          targets: background,
          opacity: [0, 1],
          duration: 500,
          easing: 'easeInOutExpo',
          complete: () => {
            anime({
              easing: 'easeInOutExpo',
              targets: content,
              opacity: [0, 1],
              duration: 250,
              complete: () => {
                resolve()
              }
            })
          }
        })
      })
    }
    
    case CLOSE: {     
      return new Promise((resolve, reject) => {  
        anime({
          targets: content,
          opacity: [1, 0],
          duration: 250,
          easing: 'easeInOutExpo',
          complete: () => {
            anime({
              easing: 'easeInOutExpo',
              targets: background,
              opacity: [1, 0],
              duration: 250,
              complete: () => {
                resolve()
              }
            })
          }
        })
      })
    }
  
    default: {
      return new Promise((resolve) => resolve())
    }
  }
  
}

export {
  animate
}